import { useIntl } from "react-intl"

import { Button, StaffBodyTextS, StaffLabelTextM } from "@doktor-se/bones-ui"
import { Role, Staff } from "@doktor-se/bones-ui/dist/web-shared/types"

import { defaultRole } from "config"

import UserOnlineStatus from "../UserRow/UserOnlineStatus"

import styles from "./ConfirmReassign.module.scss"

interface ConfirmReassignProps {
  selected: Staff
  onConfirm: () => void
  onCancel?: () => void
}

const ConfirmReassign = ({ selected, onCancel, onConfirm }: ConfirmReassignProps) => {
  const intl = useIntl()
  const role = defaultRole(selected.roles as Role[])

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.displayName}>
          <StaffLabelTextM data-testid="confirm-reassign" className={styles.text}>
            {selected.displayName}
          </StaffLabelTextM>
          <UserOnlineStatus online={!!selected.online} />
        </div>
        <StaffBodyTextS style={{ textTransform: "capitalize" }}>
          {intl.formatMessage({ id: `label.role.${role}` })}
        </StaffBodyTextS>
      </div>
      <div className={styles.buttonContainer}>
        <Button color="primary" variant="primary" onPress={onConfirm} fullWidth>
          {intl.formatMessage({ id: "label.reassign.assign" })}
        </Button>
        <Button color="primary" variant="outline" onPress={onCancel} fullWidth>
          {intl.formatMessage({ id: "label.reassign.back" })}
        </Button>
      </div>
    </>
  )
}

export default ConfirmReassign
